export default __webpack_public_path__ + "static/media/tarzan.ef24ee88.png";